import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import SocketProviderWithNavigation from "./context/socketProvider";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, responsiveFontSizes } from "@mui/material";
import { getTheme } from "./config/themes/themeConfig";
import { Toster } from "./shared/toster/Toster";
import Loader from "./components/loader/Loader";
import { I18nextProvider } from "react-i18next";
import i18n from "./config/localization/localize";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
const root = ReactDOM.createRoot(document.getElementById("root"));
const mode = localStorage.getItem("themeMode") || "light";
const theme = responsiveFontSizes(getTheme(mode));
root.render(
  //<React.StrictMode>
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <CssBaseline />
          <BrowserRouter>
            <SocketProviderWithNavigation>
              <App />
              <Toster />
              <Loader />
            </SocketProviderWithNavigation>
          </BrowserRouter>
      </I18nextProvider>
    </ThemeProvider>
  </Provider>
  //</React.StrictMode>
);
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(
      new CustomEvent("sw:update-available", { detail: registration })
    );
  },
});
// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", async () => {
//     try {
//       // Check existing service worker registrations
//       const registrations = await navigator.serviceWorker.getRegistrations();
//       console.log("Existing service worker registrations:", registrations);

//       // Check if Firebase messaging service worker is registered
//       const firebaseSW = registrations.find((reg) =>
//         reg?.active?.scriptURL?.includes("firebase-messaging-sw.js")
//       );

//       if (!firebaseSW) {
//         await navigator.serviceWorker.register("/firebase-messaging-sw.js");
//         console.log("Firebase Service Worker registered.");
//       } else {
//         console.log("Firebase Service Worker already registered.");
//       }

//       // Register main service worker if not already registered
//       const mainSW = registrations.find((reg) =>
//         reg?.active?.scriptURL?.includes("service-worker.js")
//       );
//       if (!mainSW) {
//         // await navigator.serviceWorker.register("/service-worker.js");
//         serviceWorkerRegistration.register();
//         console.log("Main Service Worker registered.");
//       } else {
//         console.log("Main Service Worker already registered.");
//       }
//     } catch (error) {
//       console.error("Service Worker registration failed:", error);
//     }
//   });
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
